import { ClientName } from '@enums/ClientName'

export const rewardsConfig = {
  local: {
    rewardClientNames: {
      health: 'rewards_uat__acko__health',
      car: 'rewards_uat__acko__auto',
      bike: 'rewards_uat__acko__auto',
      life: 'rewards_uat__acko__life',
      travel: 'rewards_uat__acko__travel',
      ackoDrive: 'rewards_uat__acko__ackodrive',
      ackoDriveService: 'rewards_uat__acko__ackodriveservice',
    },
    assetRewardIds: {
      [ClientName.CAR]: [`${process.env.ASSET_REWARD_ID_CAR}`],
    },
  },
  master: {
    rewardClientNames: {
      health: 'rewards_uat__acko__health',
      car: 'rewards_uat__acko__auto',
      bike: 'rewards_uat__acko__auto',
      life: 'rewards_uat__acko__life',
      travel: 'rewards_uat__acko__travel',
      ackoDrive: 'rewards_uat__acko__ackodrive',
      ackoDriveService: 'rewards_uat__acko__ackodriveservice',
    },
    assetRewardIds: {
      [ClientName.CAR]: [`${process.env.ASSET_REWARD_ID_CAR}`],
    },
  },
  dev: {
    rewardClientNames: {
      health: 'rewards_uat__acko__health',
      car: 'rewards_uat__acko__auto',
      bike: 'rewards_uat__acko__auto',
      life: 'rewards_uat__acko__life',
      travel: 'rewards_uat__acko__travel',
      ackoDrive: 'rewards_uat__acko__ackodrive',
      ackoDriveService: 'rewards_uat__acko__ackodriveservice',
    },
    assetRewardIds: {
      [ClientName.CAR]: [`${process.env.ASSET_REWARD_ID_CAR}`],
    },
  },
  prod: {
    rewardClientNames: {
      health: 'rewards_prod__acko__health',
      car: 'rewards_prod__acko__auto',
      bike: 'rewards_prod__acko__auto',
      life: 'rewards_prod__acko__life',
      travel: 'rewards_prod__acko__travel',
      ackoDrive: 'rewards_prod__acko__ackodrive',
      ackoDriveService: 'rewards_prod__acko__ackodriveservice',
    },
    assetRewardIds: {
      [ClientName.CAR]: [`${process.env.ASSET_REWARD_ID_CAR}`],
    },
  },
  'pre-prod': {
    rewardClientNames: {
      health: 'rewards_prod__acko__health',
      car: 'rewards_prod__acko__auto',
      bike: 'rewards_prod__acko__auto',
      life: 'rewards_prod__acko__life',
      travel: 'rewards_prod__acko__travel',
      ackoDrive: 'rewards_prod__acko__ackodrive',
      ackoDriveService: 'rewards_prod__acko__ackodriveservice',
    },
    assetRewardIds: {
      [ClientName.CAR]: [`${process.env.ASSET_REWARD_ID_CAR}`],
    },
  },
}
